import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const LinkButton = styled(Link)`
  background-color: #EB5A00;
  border-radius: 40px;
  box-shadow: 0px 0px 25px 0px #DA652900;
  color: #FFF;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 600;
  gap: 8px;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;

  &.transparent {
    background-color: transparent;
    border: 1px solid #1D1D1D;
    color: #1D1D1D;
  }
`
